import { WebLayout } from "@/components/shared/layout/homepage";
import { StickyScrollNavbar } from "@/components/shared/sticky-scroll-navbar";
import { ServiceDetail } from "@/containers/service-detail";
import type { ServiceName } from "@/types/service";
import { useParams } from "@/components/hooks/use-params";
import { ServiceDetailMenuItems } from "@/constants/booking";

export function ServiceDetailPage() {
  const { name } = useParams<{ name: ServiceName }>();

  if (!name) {
    return <div>404</div>;
  }

  return (
    <WebLayout>
      <StickyScrollNavbar
        items={ServiceDetailMenuItems}
        activeMenuKey="service"
      >
        <ServiceDetail name={name} />
      </StickyScrollNavbar>
    </WebLayout>
  );
}
